 const RAC_LPADDR = '0x024a9ad0ecfaa8b3566d3310affb358379a55e7a'

 const RAC_PLEDGE_ADDR = '0x71e3E8276746169aB606759AF18413fFD7b359C3'

 export  { RAC_LPADDR, RAC_PLEDGE_ADDR }